export default __webpack_public_path__ + "static/media/florDeJamaica.41c5176f.jpeg";